module.exports = __webpack_public_path__ + "zvetseni-prsou_9_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_9_before.jpg
// module id = 1372
// module chunks = 0